module.exports = __webpack_public_path__ + "img/sign.24f605f5.png";